import React from 'react';
import { IPaginationTable } from './interfaces';
import { Pagination as AntdPagination } from 'antd';
import Icon from '@ant-design/icons';
import { ReactComponent as ChevronIconSVG } from '../../../assets/sightx-icons/svg/icon-right-arrow.svg';

import styles from './pagination.plgexternal.module.scss';

interface IProps {
  paginationTable: IPaginationTable;
  onChangePage: (pageNumber: number, pageSize: number) => void;
}

const DEFAULT_PAGE_SIZE = 25;

type BoxType = 'page' | 'prev' | 'next' | 'jump-prev' | 'jump-next';
export const SxPagination = (props: IProps): JSX.Element => {
  const { paginationTable } = props;

  const renderLeftRight = (page: number, type: BoxType, originalElement: React.ReactElement<HTMLElement>) => {
    if (type === 'prev') {
      return <div className={styles.box}>
        <Icon className={styles.arrowLeft} component={ChevronIconSVG} />
        <span>Previous</span>
      </div>;
    }

    if (type === 'next') {
      return <div className={styles.box}>
        <span>Next</span>
        <Icon component={ChevronIconSVG} />
      </div>;
    }

    if (type === 'jump-prev' || type === 'jump-next') {
      return <span>...</span>;
    }

    return originalElement;
  };

  const onChangePage = (pageNumber: number, _pageSize?: number) => {
    props.onChangePage(pageNumber, DEFAULT_PAGE_SIZE);
  };

  return <AntdPagination
    className={styles.pagination}
    showSizeChanger={false}
    current={paginationTable.currentPage}
    total={paginationTable.totalCount}
    pageSize={paginationTable.pageSize ?? DEFAULT_PAGE_SIZE}
    onChange={onChangePage}
    itemRender={renderLeftRight}
  />;
};